import { Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "../utils/date";

@Pipe({
  name: "dateFormat",
  standalone: false,
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string | Date, type?: string): string {
    return formatDate(value, type);
  }
}
